/* global __SERVER__ */

import React from 'react';
import { func, object, bool } from 'prop-types';
import MainLayout from '@dragonfruit/layouts/MainLayout';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import SEOHead from '@dragonfruit/components/SEOHead';

import { getIsInapp } from '@dragonfruit/redux/location';

import styles from './Law.scss';

const mapStateToProps = state => ({
  isInapp: getIsInapp(state),
});

function Law({ t, isInapp }) {
  const seoComponent = (
    <SEOHead
      path="law"
      title={t('seo:seo.law.title')}
      description={t('seo:seo.law.description')}
    />
  );

  const lawContents = t('law.contents', {
    returnObjects: true,
    defaultValue: [],
  }).filter(({ description }) => description !== '-');

  const renderDetailDescr = descr => {
    const mutilLine = descr.split('・');
    if (mutilLine.length === 1) {
      return <pre className={styles.description}>{descr}</pre>;
    }

    return (
      <ul className={styles.description}>
        {mutilLine
          .filter(p => !!p)
          .map(line => (
            <li key={line}>{line}</li>
          ))}
      </ul>
    );
  };

  const renderDetail = (data, index) => (
    <div className={styles.detail} key={index}>
      <span className={styles.title}>{data.title}</span>
      {renderDetailDescr(data.description)}
    </div>
  );

  const renderContent = (
    <div className={styles.content}>
      <h2>{t('law.title')}</h2>
      {lawContents.map(renderDetail)}
    </div>
  );

  if (__SERVER__) {
    return seoComponent;
  }

  return (
    <MainLayout showHeader={!isInapp} showFooter={!isInapp}>
      {seoComponent}
      <section className={styles.container}>
        <div className={styles.row}>{renderContent}</div>
      </section>
    </MainLayout>
  );
}

Law.propTypes = {
  isInapp: bool.isRequired,
  location: object.isRequired,
  t: func.isRequired,
};

export default compose(
  translate(['law', 'seo']),
  connect(mapStateToProps)
)(Law);



// WEBPACK FOOTER //
// ./app/containers/Law/Law.jsx